import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '../../../../core/modules/common/components/Button';
import { getCurrentReport, getRequestParams, getUserType } from '../../../user/redux/selectors/UserReportSelectors';
import { getSelectionCriteria } from '../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors';
import { reportLoadData, updateReportCustomFilter } from '../redux/actions/ReportsActions';
import { getReportCustomFilter } from '../redux/selectors/ReportsSelectors';
import SelectionCriteriaDto from '../models/SelectionCriteriaDto';
import ReportDefinitions from '../../../common/config/ReportDefinitions';

class ReportCustomFiltersTrackedItemsInPresdes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      excludeEtoes: this.props.customFilter.excludeEtoes,
    };
  }

  onShowMailboxesClick = () => {
    const { reportCode } = this.props.selectionCriteria;
    const { operFrom } = this.props.requestParams;
    if (reportCode === 'TRACKED_ITEMS_IN_PREDES_DETAILS') {
      this.loadReport({
        ...this.state,
        excludeEtoes: !this.state.excludeEtoes,
        operFrom,
      });
    } else {
      this.loadReport({
        ...this.state,
        excludeEtoes: !this.state.excludeEtoes,
      });
    }
  };

  loadReport = (state) => {
    const { reportCode } = this.props.currentReport;
    const report = ReportDefinitions[reportCode];
    const selectionCriteria =
      new SelectionCriteriaDto(this.props.selectionCriteria, report.selectionCriteria.items);
    this.props.reportLoadData(report, reportCode, {
      ...selectionCriteria,
      ...state,
    });
    this.props.updateReportCustomFilter(state);
    this.setState(state);
  };

  render() {
    return (
      <div className="custom-filter-list">
        <Button
          onClick={this.onShowMailboxesClick}
          text={!this.state.excludeEtoes ?
            'app.report.exclude.etoe.button' : 'app.report.include.etoe.button'}
        />
      </div>
    );
  }
}

ReportCustomFiltersTrackedItemsInPresdes.propTypes = {
  currentReport: PropTypes.objectOf(PropTypes.shape),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  customFilter: PropTypes.objectOf(PropTypes.shape),
  reportLoadData: PropTypes.func,
  requestParams: PropTypes.objectOf(PropTypes.shape),
  updateReportCustomFilter: PropTypes.func,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    reportLoadData,
    updateReportCustomFilter,
  }, dispatch);

const mapStateToProps = state => ({
  currentReport: getCurrentReport(state),
  currentUserType: getUserType(state),
  selectionCriteria: getSelectionCriteria(state),
  customFilter: getReportCustomFilter(state),
  requestParams: getRequestParams(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportCustomFiltersTrackedItemsInPresdes);
